import { BaseTag, Flex, Text } from '@/components';
import type { ColorOptions } from '@/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  count: number;
  color?: Extract<ColorOptions, 'white' | 'magenta' | 'blue' | 'green'>;
  label: string;
};

export const HitCounter: FC<Props> = ({ count, color = 'white', label }) => {
  const { t } = useTranslation();

  return (
    <Flex gap={4} align="center">
      <BaseTag color={color}>{label}</BaseTag>
      <Text text={count} />
      <Text text={t('number-unit')} weight="regular" />
    </Flex>
  );
};
